import React from "react";

import { connect } from "react-redux";

import { getIsUserLoading } from '../../reducers/user'
import { getCurrentUser} from '../../reducers/login'
import ProjectsPage from "../../components/RoleBased/ProjectsPage";
import { Redirect } from "react-router";

const ProjectsContainer = props => {
    return props.currentUser.id && props.currentUser.optional && (props.currentUser.optional.groups || props.currentUser.optional.role === 'admin') ? <ProjectsPage {...props} /> : <Redirect to ="/noAccess" />
}

const mapState = (state, props) => ({
    userId: props.match.params.userId,
    isLoading: getIsUserLoading(state),
    currentUser : getCurrentUser(state),

});

export default connect(mapState)(ProjectsContainer);